import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl-next';
import * as bp from 'view/styles/breakpoints';
import * as grid from 'view/styles/grid';
import { TopicsList as StyledList, TopicsSection, Title } from 'view/styles/help-center';
import { token } from '@atlaskit/tokens';
import TopicsRoot from '@atlassian/help-center-common-component/topics-root';
import messages from '../topics/messages';
import { useLastLoadedTopicsCount } from '../use-last-loaded-topics-count';
import { Loader } from './styled';

export const TopicsLoader = () => {
    const { count } = useLastLoadedTopicsCount();
    const { formatMessage } = useIntl();
    if (count < 1) return null;
    return (
        <TopicsRoot>
            <Title>{formatMessage(messages.topicsSectionLabel)}</Title>
            <TopicsSection count={count}>
                <Topics count={count}>
                    {Array.from({ length: count }, (_, i) => (
                        <Topic key={i}>
                            <Loader height={24} />
                            <HelpObjects>
                                {Array.from({ length: 3 }, (_n, j) => (
                                    <HelpObject key={j}>
                                        <Icon>
                                            <Loader height={21} />
                                        </Icon>
                                        <HelpObjectLink>
                                            <Loader height={21} />
                                        </HelpObjectLink>
                                    </HelpObject>
                                ))}
                            </HelpObjects>
                        </Topic>
                    ))}
                </Topics>
            </TopicsSection>
        </TopicsRoot>
    );
};

const Topics = styled(StyledList)<{ count: number }>`
    ${bp.fromMedium.css`
    & > li {
        flex-basis: ${({ count }) => {
            if (count > 2) {
                return '33%';
            }
            if (count === 2) {
                return '50%';
            }
            return '100%';
        }};
    };`}
`;

const HelpObjects = styled.ol`
    padding: ${token('space.0', '0px')};
    list-style-type: none;
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const Topic = styled.li`
    padding: ${token('space.200', '16px')};
    box-sizing: border-box;
    margin-top: ${token('space.0', '0px')};
    & ${HelpObjects} {
        margin: 0 0 ${token('space.400', '32px')};
    }
`;

const HelpObject = styled.li`
    display: flex;
    margin-top: ${token('space.200', '16px')};
`;

const Icon = styled.div`
    width: ${grid.multiple(3).px};
    height: ${grid.multiple(3).px};
    margin-right: ${token('space.100', '8px')};
`;

const HelpObjectLink = styled.div`
    width: 60%;
`;
